<template>
	<teleport to="#app-teleport-header" class="flex-col">
		<slot />
	</teleport>
	<teleport to="#app-teleport-mobile-header" class="flex-col">
		<app-section class="flex flex-1 flex-row mt-4">
			<slot />
		</app-section>
	</teleport>
</template>

<script>
	export default {
		name: 'AppHeaderTeleport',
	};
</script>
